import { EmptystateLinkColored } from "components/icons/generated";
import CardCollapsible from "ds/components/Card/Collapsible";
import useAutoExpandOnValueChange from "ds/components/Card/Collapsible/useAutoExpandOnValueChange";
import Counter from "ds/components/Counter";
import EmptyState from "ds/components/EmptyState";
import { useToggle } from "hooks/useToggle";

import NewStackAttachedPolicy from "../AttachedPolicy";
import { AttachedPolicy } from "../types";

type NewStackManuallyAttachedPoliciesProps = {
  items: AttachedPolicy[];
};

const NewStackManuallyAttachedPolicies = ({ items }: NewStackManuallyAttachedPoliciesProps) => {
  const [isCollapsed, toggle] = useToggle(true);

  useAutoExpandOnValueChange(items.length, toggle);

  return (
    <CardCollapsible
      ariaLevel={3}
      ariaLabel="Attached directly"
      title="Attached directly"
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={items.length} />}
      contentGap="medium"
    >
      {items.length === 0 ? (
        <EmptyState
          padding="large"
          icon={EmptystateLinkColored}
          title="No policies are attached to this stack"
          caption="Use policies list to attach a policy to stack."
        />
      ) : (
        <>
          {items.map((item) => (
            <NewStackAttachedPolicy key={item.id} item={item} />
          ))}
        </>
      )}
    </CardCollapsible>
  );
};

export default NewStackManuallyAttachedPolicies;
